import { parse } from "date-fns";
import { fromZonedTime, toZonedTime } from "date-fns-tz";

// Parses an iCal date string into a Date object. I think???s
const parseICalDateTime = (dateString: string, timeZone?: string) => {
    const date = parse(dateString, "yyyyMMdd'T'HHmmssX", new Date());
    if (!timeZone) {
        return date;
    }
    return fromZonedTime(date, timeZone);
};
const parseICalDate = (dateString: string, timeZone?: string) => {
    const date = parse(dateString, "yyyyMMdd", new Date());
    if (!timeZone) {
        return date;
    }
    return fromZonedTime(date, timeZone);
};

const setDateHourToSwedishMidday = (date: Date) => {
    const swedenTimeZone = "Europe/Stockholm";
    // Create a new date object to avoid mutating the original date
    const newDate = new Date(date.getTime());
    // Convert the date to the Swedish time zone
    const zonedDate = toZonedTime(newDate, swedenTimeZone);
    // Set the time to 12:00 PM
    zonedDate.setHours(12, 0, 0, 0);
    // Convert back to UTC
    const utcDate = fromZonedTime(zonedDate, swedenTimeZone);
    return utcDate;
};
export { parseICalDate, parseICalDateTime, setDateHourToSwedishMidday };
